module.exports = __webpack_public_path__ + "static/media/terms.a6e81171.png";